import { css } from '@lastbrand/web-ui-styled-system/css'

// The host (PDP wrapper / popup) owns the column width.
export const containerDsClass = css({ width: '100%' })

export const labelDsClass = css({
  textStyle: 'body-14',
  fontWeight: 500,
  color: 'black',
  display: 'flex',
  width: '100%',
  // Pushes the Size Chart trigger to the right edge.
  justifyContent: 'space-between',
  gap: 'space-4',
})

export const optionGroupDsClass = css({
  display: 'flex',
  flexDirection: 'column',
  marginBottom: 'space-24',
})

export const optionLabelDsClass = css({ display: 'inline' })
export const selectedValueDsClass = css({ fontWeight: 400 })

export const lowInventoryMessageDsClass = css({
  textStyle: 'body-14',
  color: 'red-100',
  textAlign: 'center',
  width: 'full',
  marginBottom: 'space-10',
  lgDown: {
    marginBottom: 'space-16',
    display: 'flex',
    alignItems: 'center',
    gap: 'space-8',
    textAlign: 'left',
    padding: 0,
  },
})

export const lowInventoryIconDsClass = css({
  display: 'none',
  lgDown: { display: 'block', width: '16px', height: '16px' },
})

export const klarnaWrapperDsClass = css({
  display: 'flex',
  justifyContent: 'flex-start',
  paddingTop: '14px', // no 14px spacing token
  paddingBottom: 'space-8',
  lineHeight: '16px',
})

export const subscriptionTermsNoticeDsClass = css({
  textStyle: 'body-12',
  color: 'black',
  textAlign: 'left',
  marginTop: 'space-8',
})

export const subscriptionTermsNoticeLinkDsClass = css({
  textDecoration: 'underline',
  textUnderlineOffset: 'space-2',
})
